import React from 'react'
import errorIcon from '../../assets/icons/error_black.svg'
import successIcon from '../../assets/icons/success.svg'
import expandMoreIcon from '../../assets/icons/expand_more.svg'
import {
  DropDownContainer,
  DropdownError,
  DropDownHeader,
  DropDownIconContainer,
  DropdownInputContainer,
  DropDownList,
  DropDownListContainer,
  DropDownSubContainer,
  LabelContainer,
  ListItem
} from './styles'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faAngleDown,
  faCircleExclamation
} from '@fortawesome/free-solid-svg-icons'
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons'

const Dropdown = ({
  options,
  onChange,
  label,
  error,
  validated,
  variant = 'primary',
  size,
  value,
  inlineLabel,
  errorColor,
  validatedColor,
  dropdownIcon: ExDropdownIcon,
  errorIcon: ExErrorIcon,
  validatedIcon: ExValidatedIcon
}) => {
  const [open, setOpen] = React.useState(false)
  const [touched, setTouched] = React.useState(false)
  const [dropdownValue, setDropdownValue] = React.useState(value || '')
  const DropdownRef = React.useRef(null)

  const PRIMARY = 'primary'
  const SECONDARY = 'secondary'

  React.useEffect(() => {
    const listener = event => {
      const el = DropdownRef?.current

      // Do nothing if clicking ref's element or descendent elements
      if (!el || el.contains(event.target)) {
        return
      }
      setOpen(false)
    }

    document.addEventListener('click', listener)
    return () => {
      document.removeEventListener('click', listener)
    }
  }, [DropdownRef, open])

  const handleOpen = () => {
    setOpen(!open)
  }

  const handleClick = val => {
    setDropdownValue(val)
    if (onChange) {
      onChange(val)
    }
  }

  return (
    <>
      <DropDownContainer>
        {variant === SECONDARY && !inlineLabel && (
          <LabelContainer>{label}</LabelContainer>
        )}
        <DropDownSubContainer
          open={open}
          onClick={handleOpen}
          size={size}
          ref={DropdownRef}
          variant={variant}
        >
          <DropDownHeader
            open={open}
            onClick={() => setTouched(false)}
            error={error}
            size={size}
            validated={validated}
            variant={variant}
            validatedColor={validatedColor}
            errorColor={errorColor}
          >
            <DropdownInputContainer
              variant={variant}
              touched={touched}
              open={open}
            >
              {variant === PRIMARY &&
                (size === 'default' ||
                  size === 'full' ||
                  size === undefined) && <span>{label}</span>}
              {variant === SECONDARY &&
                inlineLabel &&
                (size === 'default' ||
                  size === 'full' ||
                  size === undefined) && <span>{label}</span>}
              <p>{value || '---'}</p>
            </DropdownInputContainer>
            <DropDownIconContainer
              validated={validated}
              error={error}
              open={open}
              variant={variant}
            >
              {ExDropdownIcon && ExErrorIcon && ExValidatedIcon ? (
                <>
                  {error && ExErrorIcon}
                  {validated && ExValidatedIcon}
                  {ExValidatedIcon}
                </>
              ) : (
                <>
                  {variant === PRIMARY && error && (
                    <FontAwesomeIcon
                      style={{ fontSize: 20, color: 'var(--red)' }}
                      icon={faCircleExclamation}
                    />
                  )}
                  {variant === PRIMARY && validated && (
                    <FontAwesomeIcon
                      style={{ fontSize: 20, color: 'var(--green)' }}
                      icon={faCircleCheck}
                    />
                  )}
                  {variant === SECONDARY && error && (
                    <img src={errorIcon} alt="Expand-Icon" />
                  )}
                  {variant === SECONDARY && validated && (
                    <img src={successIcon} alt="Expand-Icon" />
                  )}
                  {variant === PRIMARY && (
                    <FontAwesomeIcon icon={faAngleDown} />
                  )}
                  {variant === SECONDARY && !error && !validated && (
                    <img src={expandMoreIcon} alt="Expand-Icon" />
                  )}
                </>
              )}
            </DropDownIconContainer>
          </DropDownHeader>
        </DropDownSubContainer>
        <DropDownListContainer variant={variant} open={open}>
          <DropDownList>
            {options &&
              options.map(val => (
                <ListItem
                  key={val.value}
                  onClick={() => {
                    handleClick(val.value)
                    setTouched(true)
                  }}
                  variant={variant}
                >
                  {val.label}
                </ListItem>
              ))}
          </DropDownList>
        </DropDownListContainer>
      </DropDownContainer>
      {error && (
        <DropdownError errorColor={errorColor} variant={variant}>
          {error}
        </DropdownError>
      )}
    </>
  )
}

export default Dropdown



// WEBPACK FOOTER //
// ./src/components/Dropdown/index.js